import React from "react"

export default function Footer() {
  return (
    <footer className="text-light text-center w-100 footer">
      <div className="container">
        <div className="row">
          <a href="/" className="col text-light p-5 h4 light-font">
            About
          </a>
          <a className="col text-light p-5 h4 light-font">Contact Us</a>
          <a className="col text-light p-5 h4 light-font">Customer Service</a>
        </div>
      </div>
    </footer>
  )
}
